/**
 * A read that failed, as a person reads it (QA-M-08): first a sentence in the active language
 * saying what could not be loaded and what the screen does about it, then the technical
 * detail (`HTTP 503`, the server's own words) small and secondary, for whoever reports it.
 *
 * The caller passes the sentence already translated — `t()` at render time, never a string
 * stored in state — so the banner follows a language switch like the rest of the screen.
 */
export function LoadError({ message, detail, testId }: { message: string; detail?: string | null; testId?: string }) {
  return (
    <div className="banner error" role="status" data-testid={testId}>
      <span>{message}</span>
      {detail && (
        <>
          {' '}
          <span className="small muted" data-testid={testId ? `${testId}-detail` : undefined}>
            ({detail})
          </span>
        </>
      )}
    </div>
  );
}
